import React, { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';

const publicUrl = 'https://pub-796e62f6a8694829b74ff337800a1dcd.r2.dev';

// Simple unauthorized page
function InvalidAuthPage() {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <div>
        <img
          src={publicUrl + '/Desexing_Email_Banner_600x250_v2.png'}
          style={{ width: '600px', marginBottom: '20px' }}
          alt="Access Denied"
        />
      </div>
      <h1>Access Denied</h1>
      <p>
        You are not authorised to view this website. Please contact your Manager
        or email{' '}
        <a href="mailto:snipnchip@spca.nz">snipnchip@spca.nz</a> if you think
        you should be able to access this site.
      </p>
    </div>
  );
}

/**
 * Blocks access to "inspectors" or "community" hostnames
 * unless the user’s email domain contains "spca" or "xpint".
 */
export function RequirePortalDomain({ children }) {
  const { accounts } = useMsal();
  const account = (accounts && accounts[0]) || {};
  // Depending on your token config: it might be account.username or account.upn instead
  const email =
    (account.idTokenClaims && account.idTokenClaims.email) ||
    account.username ||
    '';
  const domain = email.includes('@') ? email.split('@')[1].toLowerCase() : '';

  const hostname = window.location.hostname.toLowerCase();
  const isPortal =
    hostname.includes('inspectors') || hostname.includes('community');

  const allowedSubstrings = ['spca', 'xpint','xp360'];
  const [isAllowed, setIsAllowed] = useState(null);

  useEffect(() => {
    if (!isPortal) {
      setIsAllowed(true);
    } else {
      const ok = allowedSubstrings.some(sub => domain.includes(sub));
      setIsAllowed(ok);
    }
  }, [isPortal, domain]);

  if (isAllowed === null) {
    return <p>Verifying permissions…</p>;
  }
  if (!isAllowed) {
    return <InvalidAuthPage />;
  }
  return <>{children}</>;
}
